import { render, staticRenderFns } from "./NbCardWithBtn.vue?vue&type=template&id=ccf0698e&scoped=true&"
import script from "./NbCardWithBtn.vue?vue&type=script&lang=js&"
export * from "./NbCardWithBtn.vue?vue&type=script&lang=js&"
import style0 from "./NbCardWithBtn.vue?vue&type=style&index=0&id=ccf0698e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccf0698e",
  null
  
)

export default component.exports